import { RefObject } from 'react';
import { FormattedMessage } from 'react-intl';

export interface FooterProps {
  contactRef: RefObject<HTMLDivElement | null>;
}

const Footer = ({ contactRef }: FooterProps) => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer" data-screen-label="10 Footer" ref={contactRef}>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="brand">
              <div className="brand-mark">
                <img src="/logo512.png" alt="TrainEase" />
              </div>
              <span className="brand-name">TrainEase</span>
            </div>
            <p>
              <FormattedMessage
                id="landing.footer.tagline"
                defaultMessage="La plataforma de entrenamiento personal para coaches que entrenan en serio y atletas que quieren progresar."
              />
            </p>
          </div>

          <div className="footer-col">
            <h4>
              <FormattedMessage id="landing.footer.product" defaultMessage="Producto" />
            </h4>
            <ul>
              <li>
                <a href="#features">Features</a>
              </li>
              <li>
                <a href="#precios">Precios</a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>
              <FormattedMessage id="landing.footer.audience" defaultMessage="Para" />
            </h4>
            <ul>
              <li>
                <a href="#coaches">Coaches</a>
              </li>
              <li>
                <a href="#atletas">Atletas</a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>
              <FormattedMessage id="landing.footer.support" defaultMessage="Soporte" />
            </h4>
            <ul>
              <li>
                <a href="/privacy">Privacidad</a>
              </li>
              <li>
                <a href="#faq">FAQ</a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>
              <FormattedMessage id="landing.footer.company" defaultMessage="Empresa" />
            </h4>
            <ul>
              <li>
                <a href="#">
                  <FormattedMessage id="landing.footer.about" defaultMessage="Sobre nosotros" />
                </a>
              </li>
              <li>
                <a href="#">
                  <FormattedMessage id="landing.footer.contact" defaultMessage="Contacto" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copy">© {year} TrainEase · Hecho con cariño en Buenos Aires</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
